import { render, staticRenderFns } from "./Follow.vue?vue&type=template&id=d5c43b1a&scoped=true"
import script from "./Follow.vue?vue&type=script&lang=js"
export * from "./Follow.vue?vue&type=script&lang=js"
import style0 from "./Follow.vue?vue&type=style&index=0&id=d5c43b1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5c43b1a",
  null
  
)

export default component.exports